import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  Icon,
  Card,
  CardBody,
  HStack,
} from '@chakra-ui/react';
import { FiLock, FiSettings } from 'react-icons/fi';
import { useLTI } from '../../contexts/LTIContext';

const RestrictedAccessView = () => {
  const navigate = useNavigate();
  const { isAdmin, ltiUser } = useLTI();

  const getRoleName = () => {
    if (ltiUser?.is_designer) return 'Diseñador';
    if (ltiUser?.is_observer) return 'Observador';
    return 'Usuario';
  };

  return (
    <Box maxW="5xl" mx="auto" py={8} px={4}>
      {/* Main Content */}
      <VStack spacing={6} py={12}>
        <Card maxW="2xl" w="full">
          <CardBody>
            <VStack spacing={6} textAlign="center" py={8}>
              <Icon as={FiLock} boxSize={16} color="gray.400" />
              
              <Box>
                <Heading size="lg" mb={3}>
                  Acceso Restringido
                </Heading>
                <Text color="gray.600" fontSize="lg" mb={2}>
                  Rol: {getRoleName()}
                </Text>
              </Box>

              <Text color="gray.600" maxW="md">
                Tu rol en este curso no permite acceder a la funcionalidad de certificados.
                Si necesitas acceso, por favor contacta al instructor del curso.
              </Text>

              {isAdmin() && (
                <Box pt={4}>
                  <Text fontSize="sm" color="blue.600" fontWeight="medium">
                    Como administrador, puedes acceder a la configuración del sistema
                    desde el menú "Certificate System" en la administración de Canvas.
                  </Text>
                </Box>
              )}
            </VStack>
          </CardBody>
        </Card>
      </VStack>
    </Box>
  );
};

export default RestrictedAccessView;
